











































import {
  defineComponent,
  ref,
  computed,
  useRouter,
  useContext,
} from "@nuxtjs/composition-api";
import { SfButton } from "@storefront-ui/vue";
import { useUser } from "~/modules/customer/composables/useUser";
import { useCart } from '~/modules/checkout/composables/useCart';
import { useGetWxQrcode, useUiNotification, useConfig } from "~/composables";
import moment from "moment-timezone";
import SvgImage from "~/components/General/SvgImage.vue";
import { useCustomerStore } from '~/modules/customer/stores/customer';
export default defineComponent({
  name: "CustomerLogin",
  components: {
    SvgImage,
    WeChatLoginModal: () => import("~/components/General/weChatLoginModal.vue"),
    SfButton
  },
  setup() {
    const { config } = useConfig();
    const router = useRouter();
    const { app } = useContext();
    const {
      isAuthenticated,
      customerTokenLogin,
      user,
      load: loadUser,
      logout,
    } = useUser();
    const { clear } = useCart();
    const { GetWXQrcode, GetTokenByWxApplicationLogin } = useGetWxQrcode();
    const { send: sendNotification, notifications } = useUiNotification();
    const isLoading = ref(false);
    const expirationMessage = ref("");
    const login_id = ref(null);
    const imgUrl = ref(null);
    const timezone = config.value.timezone;
    const scanStatus = ref('');
    const customerStore = useCustomerStore();
    const notificationMessage = (message: string, type: any) => {
      sendNotification({
        id: Symbol("product_removed"),
        message: message,
        type: type,
        icon: "check",
        persist: false,
        title: "Product removed",
      });
    };
    const accountIcon = computed(() =>
      isAuthenticated.value ? "profile_fill" : "profile"
    );
    const getToken = async (id: string, expireTime: number) => {
      const runAction = setInterval(async () => {
        const data = await GetTokenByWxApplicationLogin({
          login_id: id,
        });
        scanStatus.value = data["status"];
        if (data["status"] === "allow" || data["status"] === "cancel" || !isWechatModalOpen.value) {
          clearInterval(runAction);
        }
        const currentTime =
          new Date(moment(new Date()).tz(timezone).format()).getTime() / 1000;
        if (currentTime >= expireTime) {
          clearInterval(runAction);
          expirationMessage.value = "Qrcode has been expired, click reload";
        }
        if (data["token"]) {
          await customerTokenLogin(data["token"]);
          await loadUser();
          if (isAuthenticated.value) {
            notificationMessage("You have successfully logged in", "success");
          }
          isWechatModalOpen.value = false;
        }
      }, 2000);
    };

    const isWechatModalOpen = ref(false);
    const handleAccountClick = async () => {
      scanStatus.value = '';
      const apiState = app.context.$vsf.$magento.config.state;
      const baseCode = router.options.base;
      if (isAuthenticated.value) {
        if (!apiState.getCustomerToken()) {
            notificationMessage("You are not authorized, please log in.", "warning");
            const newUrl = apiState.getStore() === 'zh'? window.location.origin + baseCode : window.location.origin + baseCode + apiState.getStore();
            apiState.removeCustomerToken();
            customerStore.setIsLoggedIn(false);
            window.location.href=newUrl;
      } else {
        await router.push(app.localeRoute({ name: "customer-my-profile" }));
      }
       
      } else {
        // toggleLoginModal();
        isLoading.value = true;
        isWechatModalOpen.value = true;
        const data = await GetWXQrcode();
        expirationMessage.value = "";
        if (data["WxApplicationGenerateQrcode"].success) {
          imgUrl.value = data["WxApplicationGenerateQrcode"].image;
          login_id.value = data["WxApplicationGenerateQrcode"].login_id;
          isLoading.value = false;
          const expireTime = data["WxApplicationGenerateQrcode"].expiration_at;
          getToken(login_id.value, expireTime);
        } else {
          notificationMessage(
            data["WxApplicationGenerateQrcode"].error,
            "danger"
          );
        }
      }
    };
    return {
      isAuthenticated,
      handleAccountClick,
      imgUrl,
      isLoading,
      accountIcon,
      expirationMessage,
      isWechatModalOpen,
      scanStatus
    };
  },
});
